import type { DayKey, WorkingHours } from './useGymBranding'

export const DAYS_OF_WEEK: DayKey[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export function getTodayKey(timezone: string): DayKey {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    weekday: 'long',
  }).formatToParts(new Date())
  return (parts.find((p) => p.type === 'weekday')?.value.toLowerCase() ?? 'monday') as DayKey
}

export function isGymOpen(workingHours: WorkingHours | null, timezone: string | null): boolean {
  if (!workingHours || !timezone) return false

  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    weekday: 'long',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date())

  const weekday = (parts.find((p) => p.type === 'weekday')?.value.toLowerCase() ?? '') as DayKey
  const hour = parseInt(parts.find((p) => p.type === 'hour')?.value ?? '0') % 24
  const minute = parseInt(parts.find((p) => p.type === 'minute')?.value ?? '0')

  const day = workingHours[weekday]
  if (!day || day.closed) return false

  const currentMinutes = hour * 60 + minute
  const [openH, openM] = day.open.split(':').map(Number)
  const [closeH, closeM] = day.close.split(':').map(Number)

  return currentMinutes >= openH * 60 + openM && currentMinutes < closeH * 60 + closeM
}

export function getTimezoneCity(timezone: string): string {
  return (timezone.split('/').at(-1) ?? timezone).replace(/_/g, ' ')
}
